import * as React from "react"

import Tooltip from "@reach/tooltip"

import Row from "../../../components/row.js"
import Text from "../../../components/text.js"

const DGCSCansCount = ({count}) => (
  <Row
    centered
    height="27px"
    width="27px"
    color={count != 0 ? "white" : "text"}
    backgroundColor={count != 0 ? "#2abb9c" : "white"}
    borderRadius="default"
  >
    <Text bold={count != 0} style={{cursor: "default"}}>
      {count}
    </Text>
  </Row>
)

const DGCScansState = props => {
  const {cell} = props

  let hover = null
  if (cell?.scans?.length) {
    hover = (
      <>
        {cell.scans.map((scan, index) => {
          return (
            <Row
              key={index}
              mb={index < cell.scans.length - 1 ? 3 : 0}
              alignItems="flex-start"
            >
              <Text>{scan}</Text>
            </Row>
          )
        })}
      </>
    )
  }

  if (hover) {
    return (
      <Tooltip label={hover}>
        <span>
          <DGCSCansCount count={cell.count} />
        </span>
      </Tooltip>
    )
  }

  return <DGCSCansCount count={cell.count} />
}

export default DGCScansState
